/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@components/common';

class SelectOption extends Component {
	shouldComponentUpdate = () => false;

	handleMouseDown = (event) => {
		event.preventDefault();
		event.stopPropagation();
		const { onSelect, option } = this.props;
		onSelect(option, event);
	}

	handleMouseEnter = (event) => {
		const { onFocus, option } = this.props;

		onFocus(option, event);
	}

	handleMouseMove = (event) => {
		const { onFocus, isFocused, option } = this.props;

		if (isFocused) return;
		onFocus(option, event);
	}

	render() {
		const { option : { label, imageURL, subLabel } } = this.props;
		return (
			<div>
				<div
					className="flex padding-top-5 padding-left-10"
					onMouseDown={this.handleMouseDown}
					onMouseEnter={this.handleMouseEnter}
					onMouseMove={this.handleMouseMove}
				>
					<Image
						className="height-30 width-30 border-radius-15 margin-right-10"
						src={imageURL || ''}
					/>
					<p className="margin-bottom-0">
						<span className="font-regular display-block color-gray-mine-shaft font-size-12">{ label }</span>
						<span className="font-regular display-block color-blue-bayoux font-size-10">{ subLabel }</span>
					</p>
				</div>
				<div className="separator" />
			</div>
		);
	}
}

SelectOption.propTypes = {
	isFocused : PropTypes.bool,
	onFocus   : PropTypes.func,
	onSelect  : PropTypes.func,
	option    : PropTypes.object,
};

SelectOption.defaultProps = {
	isFocused : false,
	onFocus   : () => undefined,
	onSelect  : () => undefined,
	option    : {},
};

export default SelectOption;
